module.exports = __webpack_public_path__ + "static/media/sp41.ad0c0615.JPG";